import { ROUTE_MAP } from "../../constants/routes";

/**
 * [polecenie właściciela 2026-09-16] OBSZARY OBJĘTE ZNAKIEM WODNYM I BLOKADĄ WYDRUKU.
 *
 * Właściciel pytał, czy aplikacja może wykryć zrzut ekranu i zaciemnić się albo podmienić dane na
 * anonimowe „na czas robienia zrzutu". ODPOWIEDŹ, którą trzeba tu zapisać, żeby nikt jej później nie
 * wymyślał od nowa: PRZEGLĄDARKA NIE MA TAKIEGO MECHANIZMU. Zrzut ekranu robi system operacyjny —
 * strona nie dostaje o nim żadnego zdarzenia, nie da się go ani wykryć, ani przerwać, ani zdążyć
 * zmienić treści „na czas zrzutu". Klawisz PrintScreen bywa widoczny w `keydown`, ale to wyłącznie
 * jeden ze sposobów, a wycinanie fragmentu ekranu narzędziem systemowym nie dotyka klawiatury wcale.
 *
 * ZAKRES UZGODNIONY Z WŁAŚCICIELEM (jego słowa: „tak, tym zakresem"): zamiast obietnicy, której nie
 * da się dotrzymać, robimy dwie rzeczy, które DZIAŁAJĄ NAPRAWDĘ:
 *   1. ZNAK WODNY z imieniem, nazwiskiem, kontem i czasem — zrzut ekranu wychodzi podpisany, więc
 *      wyciek da się przypisać do osoby. To jest środek odstraszający i dowodowy, nie techniczna
 *      blokada, i tak trzeba o nim mówić.
 *   2. TWARDA BLOKADA WYDRUKU I „DRUKUJ DO PDF" — tu przeglądarka daje realne narzędzie
 *      (`@media print`), więc najprostsza droga do czystej kopii dokumentu zostaje zamknięta.
 *
 * Lista obszarów jest LISTĄ TRAS, a nie listą komponentów, i to świadomie: obszar chroniony to
 * adres wraz ze wszystkim, co pod nim (podstrony, zakładki, szuflady). Gdyby ochronę wpinać
 * w komponenty stron, każda nowa podstrona e-teczki wymagałaby pamiętania o niej z osobna.
 */

/** Klucze tras z `ROUTE_MAP` — bierzemy OBIE wersje językowe, bo adres bywa polski i angielski. */
const KLUCZE_TRAS = [
    // E-teczka pracownika: akta, dane kadrowe, rozliczenia, notatki.
    "eTeczka",
    // Kartoteka pracowników (panel administracyjny) razem z kartą czasu pracy osoby.
    "adminEmployees",
    // Sprawy kadrowe — kolejka i karty spraw modułu HR.
    "hrManagement",
    // Sygnalista: zgłoszenie pracownika i konsola obsługi naruszeń.
    "sygnalista",
    "hrSygnalista",
    // Menedżer haseł: sejf osobisty, bank działu, bank IT, banki modułów.
    "sejf",
    "myDeptSejf",
    "itSejf",
    // Analityka czasu pracy — własna, działu i centralna.
    "hrMyWorkTime",
    "myDeptWorkTime",
];

/** Adresy spoza `ROUTE_MAP` (trasy statyczne definiowane wprost w App.js). */
const ADRESY_WPROST = [
    // Kafelki panelu administracyjnego (slug → /admin/<slug>, patrz `adminTilesConfig`).
    "/admin/worktime-analytics",   // analityka czasu pracy — centralna
    "/admin/password-manager",     // menedżer haseł — wgląd centralny
    "/admin/sygnalista-handling",  // sygnalista — konsola obsługi naruszeń
    "/admin/employees",            // kartoteka pracowników (ta sama strona, co `adminEmployees`)
];

/** Prefiksy adresów objętych ochroną — wyliczone raz, bo lista tras jest stała. */
export const PREFIKSY_CHRONIONE = (() => {
    const zbior = new Set(ADRESY_WPROST);
    KLUCZE_TRAS.forEach((klucz) => {
        const trasa = ROUTE_MAP[klucz];
        if (!trasa) return;
        // Wzorce z parametrem (`/admin/pracownicy/:userId/czas-pracy`) obcinamy do części stałej —
        // ochrona ma objąć całe poddrzewo, a nie konkretny identyfikator.
        [trasa.pl, trasa.en].filter(Boolean).forEach((sciezka) => {
            const stala = sciezka.split("/:")[0];
            if (stala && stala !== "/") zbior.add(stala);
        });
    });
    return [...zbior];
})();

/**
 * Czy podany adres należy do obszaru chronionego.
 *
 * ⚠️ Porównujemy po GRANICY SEGMENTU, nie po zwykłym „zaczyna się od": „/sygnalista" ma objąć
 * „/sygnalista/12", ale NIE „/sygnalista-informacje". Ta sama zasada, co w `pathStartsWith`.
 */
export const czyObszarChroniony = (sciezka) => {
    const adres = String(sciezka || "").split("?")[0].split("#")[0];
    return PREFIKSY_CHRONIONE.some((p) => adres === p || adres.startsWith(`${p}/`));
};
